import { useTaskRiskPolicy } from '../../features/settings';
import { formatDateTime } from '../../lib/format';

export function TaskRiskPolicyPage() {
  const {
    data,
    loading,
    saving,
    error,
    maxEffectiveAssignmentsPerTaskIP,
    setMaxEffectiveAssignmentsPerTaskIP,
    ipMatchMode,
    setIPMatchMode,
    claimRequireWithdrawalAccount,
    setClaimRequireWithdrawalAccount,
    save,
    reload,
  } = useTaskRiskPolicy();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-6 w-6 border-2 border-gray-300 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-20 text-center">
        <p className="text-sm text-red-500 mb-3">{error}</p>
        <button onClick={reload} className="text-sm text-primary hover:underline">
          重试
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl space-y-6">
      <p className="text-sm text-gray-500">
        配置同一任务下同一 IP 可保有的有效领取/提交数量，0 表示不限制。
      </p>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            同任务同 IP 有效数量上限
          </label>
          <input
            type="number"
            min={0}
            value={Number.isNaN(maxEffectiveAssignmentsPerTaskIP) ? '' : maxEffectiveAssignmentsPerTaskIP}
            onChange={(e) => {
              const value = e.target.value;
              setMaxEffectiveAssignmentsPerTaskIP(value === '' ? Number.NaN : Number(value));
            }}
            className="h-9 w-60 rounded-md border border-gray-300 px-3 text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
          <p className="mt-2 text-xs text-gray-400">
            领取任务和提交任务都会判断。超过限制时 App 返回“当前任务受限，请尝试其他任务”。
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            IP 匹配模式
          </label>
          <select
            value={ipMatchMode}
            onChange={(e) => setIPMatchMode(e.target.value as 'exact' | 'ipv4_24' | 'ipv4_16')}
            className="h-9 w-60 rounded-md border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          >
            <option value="exact">精确 IP</option>
            <option value="ipv4_24">IPv4 /24 网段</option>
            <option value="ipv4_16">IPv4 /16 网段</option>
          </select>
          <p className="mt-2 text-xs text-gray-400">
            /24 会把 113.185.47.* 视为同一网络；/16 会把 113.185.*.* 视为同一网络。
          </p>
        </div>

        <label className="flex max-w-xl items-start gap-3 rounded-lg border border-gray-200 bg-white p-4">
          <input
            type="checkbox"
            checked={claimRequireWithdrawalAccount}
            onChange={(e) => setClaimRequireWithdrawalAccount(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary/50"
          />
          <span>
            <span className="block text-sm font-medium text-gray-700">
              领取任务前必须绑定支付宝提现账号
            </span>
            <span className="mt-1 block text-xs text-gray-400">
              开启后，App 会在领取任务前提示用户先绑定提现账号；后端领取接口也会拦截未绑定用户。
            </span>
          </span>
        </label>

        <div>
          <button
            onClick={save}
            disabled={saving}
            className="inline-flex items-center gap-2 bg-primary text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-primary-hover disabled:opacity-50 transition-colors"
          >
            {saving && (
              <span className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            )}
            保存
          </button>
        </div>
      </div>

      {data && (
        <div className="pt-4 border-t border-gray-200 text-xs text-gray-400 space-y-1">
          <p>最后更新：{formatDateTime(data.updated_at)}</p>
          {data.updated_by != null && <p>操作人 ID：{data.updated_by}</p>}
        </div>
      )}
    </div>
  );
}
